<template>
  <el-config-provider :locale="locale">
    <router-view></router-view>
  </el-config-provider>
</template>

<script setup>
import '@/assets/font/iconfont.css';
import { ref , computed} from 'vue';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import en from 'element-plus/dist/locale/en.mjs';
import { post } from '@/api';
import { getItem, setItem } from './assets/js/storage'
import { useRouter } from 'vue-router';
import { tool } from '@/stores/tool.js';
import { useI18n } from 'vue-i18n';

const $router = useRouter();
const storage = ['sidetag', 'userInfo', 'sideView', 'sideBar', 'route', 'wasteType', 'socket', 'token']; // 本地所有缓存
storage.some(e => {
  if (!getItem(e)) {
    // 先保存 fieldData（如果存在）
    tool().clearSpecificCache();
    // 重置 Pinia 状态
    tool().$reset();
    $router.push('/login');
    return true;
  }
})

// 强制重新登录，只需要修改ver的版本号就可以了
const getUser = () => {
  post('/portal/userInfo');
}
if (getItem('token')) {
  getUser();
}

// const locale = ref(zhCn);
const { locale: i18nLocale } = useI18n();
const locale = computed(() => {
  return i18nLocale.value === 'en-US' ? en : zhCn;
});
</script>

<style lang="scss">
@import url("./assets/css/reset.css");
@import url("./assets/css/common.css");

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

html,
body {
  overflow: hidden;
  background-color: #F5FAF5;
}

.virtual {
  width: 16px;
  height: 16px;
  margin-right: 6px;
  vertical-align: top;
}

img {
  width: 100%;
}

.td .el-form-item {
  margin-bottom: 8px;
}

.box {
  padding: 14px;
  background-color: #fff;
  height: calc(100% - 42px);
}

.page {
  padding-top: 14px;
}

.pointer {
  cursor: pointer;
}

.td .element-icons {
  font-size: 14px !important;
  margin-right: 6px;
}

.tableBtn.el-popover .el-select {
  .el-input {
    .el-input__wrapper {
      padding-right: 7px;
    }

  }
}

.tableBtn.el-popover .el-input {
  .el-input__wrapper {
    padding: 0;

    .el-input__inner {
      padding: 0 10px;
    }
  }
}

.popoverMessage.el-popover.el-popper {
  padding: 12px 0;
}
</style>